import { useEffect, useLayoutEffect, useRef, useState } from "react"
import { Table } from "simplygrow-ui"

import { ProfilePk, ColumnConfig, IntegrationWarnings } from "../../../types"
import { TableService } from "../../../services"
import { ColorPalette } from "../../../config"
import ButtonGrey from "../../BaseComponents/Buttons/ButtonGrey"
import ButtonBlue from "../../BaseComponents/Buttons/ButtonBlue"
import { toUpperCaseCustom } from "../../../utils"
// import { TABLE_ROW_HEIGHT } from "../../../constants/table"

type ProfileIntegrationWarningModalProps = {
  data: IntegrationWarnings[]
  onRowClick: (profilePk: ProfilePk) => void
  onClose: () => void
  onResolvedClick: (profilesPks: ProfilePk[]) => void
  onProfileSelect: (profileIds: ProfilePk[]) => void
}

const tableService = new TableService()
const tableColumnConfig = [
  {
    key: "target",
    label: "System",
    sizeFactor: 1,
  },
  {
    key: "person",
    label: "Person",
    sizeFactor: 2,
  },
  {
    key: "message",
    label: "Message",
    sizeFactor: 4,
  },
] as ColumnConfig[]

export const ProfileIntegrationWarningModal = (props: ProfileIntegrationWarningModalProps) => {
  const [tableData, setTableData] = useState<Record<string, string>[]>([])
  const [refreshTimestamp, setRefreshTimestamp] = useState<number>(Date.now())
  const [tableHeight, setTableHeight] = useState<number>(500)
  const [selectedProfileIds, setSelectedProfileIds] = useState<ProfilePk[]>([])

  useEffect(() => {
    setTableData(prepareProfileDataForDisplay(props.data))
  }, [props.data])

  const prepareProfileDataForDisplay = (warnings: IntegrationWarnings[] = []) => {
    console.log("warnings: ", warnings)
    return warnings.map((warning) => {
      const { profilePk, name, surname, target, message } = warning
      return {
        id: profilePk,
        target: toUpperCaseCustom(target),
        person: toUpperCaseCustom(`${name} ${surname}`),
        message,
      }
    })
  }

  const onResolvedClick = () => {
    console.log("onResolvedClick: ", selectedProfileIds)
    props.onResolvedClick(selectedProfileIds)
  }

  const onRowClick = (rowData: Record<string, string>) => {
    console.log("rowData: ", rowData)
    props.onRowClick(rowData.id)
  }

  const columnConfig = tableService.convertPfColumnConfigToGridColDef(tableColumnConfig)
  return (
    // Copied from ConfirmChanges.tsx
    <div style={{ ...styles.screenContainer }}>
      <button style={styles.backgroundOverlay} onClick={() => props.onClose()} />

      <div style={{ ...styles.cardContainer }}>
        <h1 style={{ ...styles.textStyle, fontWeight: "bold", fontSize: "1rem", marginTop: 5 }}>
          3rd PARTY SYNC ISSUES
        </h1>
        <h1 style={{ ...styles.textStyle, marginBottom: 15, fontWeight: "100" }}>
          The following issues are preventing changes syncing with 3rd party systems. Resolve them for syncing to
          continue.
        </h1>

        <div style={{ width: "100%", maxHeight: "65vh", marginTop: 10 }}>
          <Table
            rows={tableData}
            columns={columnConfig}
            tableHeight={tableHeight}
            rowSelection={true}
            onRowClick={(rowData: Record<string, any>) => onRowClick(rowData)}
            onRowSelection={setSelectedProfileIds}
            key={`dataTable_NavBar_${refreshTimestamp}`}
          />
        </div>

        <div style={styles.buttonContainer}>
          <ButtonGrey style={{ width: "48%" }} onClick={props.onClose}>
            Close
          </ButtonGrey>
          <ButtonBlue style={{ width: "48%" }} onClick={onResolvedClick}>
            Mark as resolved
          </ButtonBlue>
        </div>
      </div>
    </div>
  )
}

const styles = {
  screenContainer: {
    position: "absolute" as "absolute",
    top: 0,
    left: 0,
    backgroundColor: ColorPalette.MODAL_BACKGROUND_OVERLAY,
    width: window.innerWidth,
    height: window.innerHeight,
    zIndex: 100000,
    overflow: "hidden",
  },
  backgroundOverlay: {
    position: "absolute" as "absolute",
    top: 0,
    left: 0,
    width: window.innerWidth,
    height: window.innerHeight,
    backgroundColor: "transparent",
    zIndex: 10000,
    outline: 0,
    border: "none",
  },
  cardContainer: {
    position: "absolute" as "absolute",
    top: 20,
    left: window.innerWidth * 0.15,
    zIndex: 100000,
    display: "flex",
    flexDirection: "column" as "column",
    alignItems: "center",
    boxShadow: "0px 2px 8px rgba(0, 0, 30, 0.2)",
    backgroundColor: ColorPalette.CARD_WHITE,
    width: window.innerWidth * 0.7,
    padding: 30,
    borderRadius: 8,
  },
  buttonContainer: {
    width: "92%",
    display: "flex",
    flexDirection: "row" as "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 40,
    paddingBottom: 10,
  },
  textStyle: {
    marginTop: 5,
    textAlign: "center" as "center",
    alignSelf: "center",
    fontFamily: "roboto",
    fontWeight: "normal",
    color: ColorPalette.PRIMARY_TEXT,
    fontSize: "0.95rem",
    paddingLeft: 10,
    paddingRight: 10,
  },
}
